module.exports = __webpack_public_path__ + "media/fonts/bootstrap-icons-be6df3f0.woff";